import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7354192e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "frontline-dashboard-mobile" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "safe-area-inset-top" }, null, -1))
const _hoisted_3 = {
  key: "fm-dash-header",
  class: "section section--header"
}
const _hoisted_4 = { class: "welcome-message" }
const _hoisted_5 = { class: "dashboard-filter-bar" }
const _hoisted_6 = {
  key: "fm-dash-responses",
  class: "section section--row"
}

import { computed, onBeforeMount, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { Style } from '@capacitor/status-bar'
import { setStatusBarStyle } from '@/mobile/src/utils/capacitor'
import { useFrontlineManagerDash } from '@/composables/useFrontlineManagerDash'
import { useFrontlineStaffDash } from '@/composables/useFrontlineStaffDash'
import UserFocusArea from '@/components/FrontlineStaffDash/UserFocusArea.vue'
import FilterBarTime from '@/components/PrimeVue/FilterBarTime.vue'
import FilterBarQuestionType from '@/components/PrimeVue/FilterBarQuestionType.vue'
import { TimeOptionLabel } from '@/utils/time'


export default /*#__PURE__*/_defineComponent({
  __name: 'FrontlineStaffDashboardMobile',
  setup(__props) {

const store = useStore()

const {
    timeFilter,
    metricFilter,
    welcomeMessage,
    setTimeFilter,
    saveTimeFilter,
} = useFrontlineManagerDash()

const {
    loadingUserFocusArea,
    hasErrorUserFocusArea,
    userFocusArea,
    isPageLoading,
    fetchPageData,
    fetchUserFocusArea,
    acknowledgeFocusAreaAction,
} = useFrontlineStaffDash()

const userName = computed(() => store.getters['userFirstName'])
const companyVars = computed(() => store.getters['$companyVars'])
const activeMetrics = computed(() => store.getters['activeMetrics'])

const savedTimeFilter = computed(
    () => store.getters['getCopilotDashboardFilters']
)

onBeforeMount(async () => {
    await store.dispatch('getFilters') //Make sure the user lock filters are loaded
    metricFilter.value = store.getters.filterQuestionType ?? 'nps'

    if (savedTimeFilter.value) {
        setTimeFilter(savedTimeFilter.value)
    }

    await fetchPageData(companyVars.value.has_team_goal)
})

onMounted(async () => {
    await setStatusBarStyle(Style.Light)
})

onUnmounted(async () => {
    await setStatusBarStyle(Style.Dark)
})

const onFilterChange = async (timeOption?: TimeOptionLabel) => {
    if (timeOption) {
        saveTimeFilter(timeOption)
    }

    await fetchPageData(companyVars.value.has_team_goal)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_TransitionGroup, { name: "dashboard-layout" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(welcomeMessage)(userName.value)), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(FilterBarTime, {
              modelValue: _unref(timeFilter),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(timeFilter) ? (timeFilter).value = $event : null)),
              disabled: _unref(isPageLoading),
              "data-testid": "fm-dash-time-filter",
              onFilterChanged: onFilterChange
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(FilterBarQuestionType, {
              modelValue: _unref(metricFilter),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(metricFilter) ? (metricFilter).value = $event : null)),
              disabled: _unref(isPageLoading),
              "active-metrics": activeMetrics.value,
              "is-multi-metric": 
                            !!companyVars.value?.has_lead_with_any_question
                        ,
              onFilterChanged: onFilterChange
            }, null, 8, ["modelValue", "disabled", "active-metrics", "is-multi-metric"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(UserFocusArea, {
            "on-reload-click": _unref(fetchUserFocusArea),
            "focus-area": _unref(userFocusArea),
            "on-action-acknowledge": _unref(acknowledgeFocusAreaAction),
            loading: _unref(loadingUserFocusArea),
            "show-error": _unref(hasErrorUserFocusArea)
          }, null, 8, ["on-reload-click", "focus-area", "on-action-acknowledge", "loading", "show-error"])
        ])
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})